import "./Volante.css";

import { useAsyncExecutor2 } from "async-executor-hook";
import { addDays, differenceInDays, format, parse } from "date-fns";
import { Dropdown } from "primereact/dropdown";
import { Sidebar } from "primereact/sidebar";
import { Skeleton } from "primereact/skeleton";
import { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-date-picker";

import { Authorization } from "../../common/AuthorizationCpt";
import IconServiceMore from "../../images/icon_service_more.svg";
import { LIMIT_DAYS_FOR_WITHDRAWAL_DATE } from "../../utils/constants";
import { dateToRegularFormat } from "../../utils/dates";
import { formatMoney, formatNumber } from "../../utils/numbers";
import AdditionalInfoReviewingModal from "../AdditionalVolanteModal/AdditionalInfoReviewingModal";
import AdditionalRucsModal from "../AdditionalVolanteModal/AdditionalRucsModal";
import AdditionalServiceStatusModal from "../AdditionalVolanteModal/AdditionalServiceStatusModal";

import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import FileUploadAuthorizationModal from "../FileUploadAuthorizationModal/FileUploadAuthorizationModal";
import VolanteDetailCpt from "../VolanteDetail/VolanteDetail";
import VolanteDetails from "../VolanteDetails/VolanteDetails";
import { DetailsContainer } from "../VolanteDetails/VolanteDetailsStyles";
import { VolanteAdditionalServices } from "./VolanteAdditionalServices";
import {
  getVolantePricing,
  IEstimateDamData,
} from "../BillingScreen/BillingScreen";
import { QuotationSkeleton } from "../VolanteAdmin/QuotationSkeleton";
import {
  DivDate,
  DivDropdown,
  FlightInfo,
  MainButton,
  OptionTemplateVolante,
  StatusBar,
  StatusDiv,
  StatusSection,
  VolanteDescription,
  VolanteDetail,
  VolanteHeader,
} from "./VolanteStyles";
import { IntranetStatusSectionDetails } from "./IntranetStatusSectionDetails";

const detaultAmount = {
  sellingValue: { pen: 0, usd: 0 },
  discount: { pen: 0, usd: 0 },
  netValue: { pen: 0, usd: 0 },
  igv: { pen: 0, usd: 0 },
  sellingPrice: { pen: 0, usd: 0 },
  amount: 0,
};

const getQuotationCacheKey = (date: string, services: any[]) =>
  JSON.stringify({
    date,
    services: services
      .map(({ sap_code, amount }) => ({ sap_code, amount }))
      .sort((first, second) =>
        String(first.sap_code).localeCompare(String(second.sap_code))
      ),
  });

export const extractDataQuotationEstimate = (response) => {
  const quotation_details = response.quotation_details.map((detail, index) => {
    return {
      id: index,
      description: detail.description,
      sellingValue: detail.sales_value,
      discount: detail.discount,
      netValue: detail.net_value,
      igv: detail.sales_tax,
      sellingPrice: detail.sales_price,
      category: detail.category,
      amount: detail.amount,
      sap_code: detail.sap_code,
    };
  });

  const total = {
    id: "totalId",
    description: "Total",
    sellingValue: response.sales_value_total,
    discount: response.discount_total,
    netValue: response.net_value_total,
    igv: response.sales_tax_total,
    sellingPrice: response.sales_price_total,
    amount: response.amount_total,
  };

  return { quotation_details, total };
};

function Volante(props) {
  const {
    damStatus,
    dni,
    volante,
    enableCheckbox,
    checkboxOnChange,
    checked,
    dateRucHook,
    disabled,
    updateVolanteThirdParty,
    onChangeVolantesForInvoice,
    refreshBilling,
  } = props;
  const {
    id,
    importer,
    weight,
    parcels,
    rucs,
    airline,
    flightDate,
    masterAirWaybill,
    houseAirWaybill,
    thirdPartyStatus,
    paymentStatus,
    billableRuc,
    withdrawalDate,
    salesPriceTotal,
    entryDate,
    contentDescription,
  } = volante;
  const [restrictions, setRestrictions] = useState(0);
  useEffect(() => {
    const restrictions =
      damStatus.problems.length + volante.status2.problems.length;
    setRestrictions(restrictions);
  }, [damStatus, volante.status2]);

  const [amount, updateAmount] = useState(
    paymentStatus !== "unquoted" ? salesPriceTotal : "(No cotizado)"
  );
  const [quotationProcessStatus, setQuotationProcessStatus] =
    useState<any>(null);
  const [selectedRuc, updateSelectedRuc] = useState(
    ["reviewing", "approved"].includes(thirdPartyStatus.option) ? "other" : "0"
  );
  const [showDetail, updateShowDetail] = useState(true);
  const [showRucModal, updateShowRucModal] = useState(false);
  const [showServiceStatusModal, updateShowServiceStatusModal] =
    useState(false);
  const [showUploadFileModal, updateShowUploadFileModal] = useState(false);
  const [rucOptions, updateRucOptions] = useState(rucs);
  const [otherRucInfo, updateOtherRucInfo] = useState(null);
  const [useDollars] = useContext(CurrencyContext);
  const [uploadDate, updateUploadDate] = useState<any>();
  useEffect(() => {
    dateRucHook[1]((oldDateRuc) => {
      const newDateRucStatus = { ...oldDateRuc };
      newDateRucStatus[id] = {
        amount: amount,
        billableRuc: selectedRuc,
        withdrawalDate1: uploadDate,
      };
      return newDateRucStatus;
    });
    // eslint-disable-next-line
  }, [selectedRuc, amount, id, uploadDate]);

  const toggleRucModal = (showFileModal) => {
    if (showFileModal) {
      updateShowUploadFileModal(true);
    }
    updateShowRucModal(!showRucModal);
  };

  const closeModalRuc = () => {
    updateShowRucModal(false);
    setSelectedCountry(null);
  };
  const [quotationDetails, setQuotationDetails] = useState([]);

  const [, setOriginalQuotationDetailsTotal] = useState(detaultAmount);

  const [daysStored, setDaysStored] = useState(volante.days_stored);
  const [quotationDetailsTotal, setQuotationDetailsTotal] =
    useState(detaultAmount);

  const toggleDetail = () => {
    restrictions === 0 && updateShowDetail(!showDetail);
  };

  const [volanteServiceSidebar, setVolanteServiceSidebar] = useState(false);

  const toggleVolanteServiceSidebar = (e) => {
    setVolanteServiceSidebar(!volanteServiceSidebar);
    e?.stopPropagation();
  };

  const toggleServices = (e) => {
    if (isReviewing) {
      updateShowServiceStatusModal(true);
      e?.stopPropagation();
    } else {
      toggleVolanteServiceSidebar(e);
    }
  };

  const [additionalServices, setAdditionalServices] = useState([]);
  // services committed by the user — carried forward across date changes
  const committedAdditionalServicesRef = useRef<any[]>([]);

  useEffect(() => {
    volante.additional_services = additionalServices;
  }, [volante, additionalServices]);

  const uploadDateOnChange = (newDate) => {
    updateUploadDate(newDate);
    const dateToday = new Date();
    const resultDifferenceDay = differenceInDays(newDate, dateToday);
    const formatDateToday = format(dateToday, "yyyy-MM-dd");
    const formatNewDate = format(newDate, "yyyy-MM-dd");
    if (formatDateToday === formatNewDate) {
      setDaysStored(volante.days + resultDifferenceDay);
    } else {
      setDaysStored(volante.days + (resultDifferenceDay + 1));
    }
  };

  const [deletedItemsByDate, setDeletedItemsByDate] = useState({});

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  const getVolantePricingExecutor = useAsyncExecutor2<IEstimateDamData, any>(
    (params) => getVolantePricing(params),
    { cache: false, sequential: "SWITCH" }
  );
  const isFetchingQuotation = getVolantePricingExecutor.isLoading;

  const [quotationEntry, setQuotationEntry] = useState<any>(null);
  const quotationsCacheRef = useRef<{ [key: string]: any }>({});
  const activeQuotationKeyRef = useRef<string>();
  const quotationsInitializedRef = useRef(false);

  useEffect(() => {
    if (quotationsInitializedRef.current) return;
    quotationsInitializedRef.current = true;
    const initialQuotations = volante.pricing?.quotation_estimate_list || [];
    initialQuotations.forEach((entry) => {
      const services = (entry.quotation_details || [])
        .filter((detail) => detail.category === "additional_service")
        .map(({ sap_code, amount }) => ({ sap_code, amount }));
      quotationsCacheRef.current[
        getQuotationCacheKey(entry.withdrawal_date, services)
      ] = entry;
    });
    const firstEntry = [...initialQuotations].sort((first, second) =>
      first.withdrawal_date.localeCompare(second.withdrawal_date)
    )[0];
    committedAdditionalServicesRef.current = firstEntry
      ? (firstEntry.quotation_details || [])
          .filter((detail) => detail.category === "additional_service")
          .map(({ sap_code, amount }) => ({ sap_code, amount }))
      : [];
  }, [volante.pricing?.quotation_estimate_list]);

  const loadQuotation = (date: string, services: any[], callbacks: any = {}) => {
    const key = getQuotationCacheKey(date, services);
    activeQuotationKeyRef.current = key;
    const cachedEntry = quotationsCacheRef.current[key];
    if (cachedEntry) {
      setQuotationEntry(cachedEntry);
      callbacks.onSuccess?.({
        quotation_data: [{ quotation_estimate_list: [cachedEntry] }],
      });
      return;
    }

    setQuotationEntry(null);
    getVolantePricingExecutor.execute(
      {
        dam_num: volante.pricing.dam_num,
        document_number: dni,
        withdrawal_date: date,
        volantes: [{ additional_services: services, volante_num: id }],
      },
      {
        onSuccess: (data) => {
          const entry = data?.quotation_data?.[0]?.quotation_estimate_list?.[0];
          if (entry && entry.withdrawal_date === date) {
            quotationsCacheRef.current[key] = entry;
            if (activeQuotationKeyRef.current === key) {
              setQuotationEntry(entry);
            }
          }
          callbacks.onSuccess?.(data);
        },
        onError: callbacks.onError,
      } as any
    );
  };

  useEffect(() => {
    const { quotation_estimate_list } = volante.pricing;

    const lowestDate = quotation_estimate_list
      .map((quotation) => {
        return parse(quotation.withdrawal_date, "yyyy-MM-dd", new Date());
      })
      .reduce((t, e) => {
        return t.getTime() < e.getTime() ? t : e;
      }, new Date(100000000000000));

    setMinDate(lowestDate);
    updateUploadDate((uploadDate) => {
      return uploadDate ? uploadDate : lowestDate;
    });

    setMaxDate(addDays(lowestDate, LIMIT_DAYS_FOR_WITHDRAWAL_DATE - 1));
  }, [volante]);

  useEffect(() => {
    if (!uploadDate) return;
    loadQuotation(
      format(uploadDate, "yyyy-MM-dd"),
      committedAdditionalServicesRef.current
    );
    // eslint-disable-next-line
  }, [uploadDate]);

  useEffect(() => {
    if (!uploadDate || isFetchingQuotation) return;

    const index = format(uploadDate, "yyyy-MM-dd");
    const response = quotationEntry;
    if (!response || response.withdrawal_date !== index) return;

    const deletedAdditionalServices = deletedItemsByDate[index] || [];
    setIsReviewing(
      volante.third_party_billing_authorization_status.option === "reviewing"
    );
    const { quotation_details, total } = extractDataQuotationEstimate(response);
    const filtered_quotation_details = quotation_details.filter((detail) => {
      return !deletedAdditionalServices.includes(detail.sap_code);
    });
    setAdditionalServices(
      filtered_quotation_details
        .filter((i) => i.category === "additional_service")
        .map((i) => ({ sap_code: i.sap_code, amount: i.amount }))
    );
    setQuotationDetails(filtered_quotation_details);
    setOriginalQuotationDetailsTotal(total);

    if (deletedAdditionalServices.length > 0) {
      const result = filtered_quotation_details.reduce(
        (cumulative, element) => {
          return {
            amount: cumulative.amount + element.amount,
            sellingValue: {
              usd: cumulative.sellingValue.usd + element.sellingValue.usd,
              pen: cumulative.sellingValue.pen + element.sellingValue.pen,
            },
            discount: {
              usd: cumulative.discount.usd + element.discount.usd,
              pen: cumulative.discount.pen + element.discount.pen,
            },
            netValue: {
              usd: cumulative.netValue.usd + element.netValue.usd,
              pen: cumulative.netValue.pen + element.netValue.pen,
            },
            igv: {
              usd: cumulative.igv.usd + element.igv.usd,
              pen: cumulative.igv.pen + element.igv.pen,
            },
            sellingPrice: {
              usd: cumulative.sellingPrice.usd + element.sellingPrice.usd,
              pen: cumulative.sellingPrice.pen + element.sellingPrice.pen,
            },
          };
        },
        detaultAmount
      );
      setQuotationDetailsTotal(result);
      updateAmount(result.sellingPrice);
    } else {
      setQuotationDetailsTotal(total);
      updateAmount(response.sales_price_total);
      setQuotationProcessStatus(response.quotation_process_status);
    }
  }, [
    quotationEntry,
    isFetchingQuotation,
    uploadDate,
    deletedItemsByDate,
    volante.third_party_billing_authorization_status.option,
  ]);

  useEffect(() => {
    volante.withdrawal_date = new Date(uploadDate);
  }, [volante, uploadDate]);

  const [isReviewing, setIsReviewing] = useState(
    thirdPartyStatus.option === "reviewing"
  );

  const [
    showConfirmationModalVolanteDocument,
    setShowConfirmationModalVolanteDocument,
  ] = useState(false);

  const [showModalErrorAdditionalRucs, setShowModalErrorAdditionalRucs] =
    useState(false);
  const [showModalMessageAdditionalRucs, setShowModalMessageAdditionalRucs] =
    useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);

  const onCountryChange = (e) => {
    setSelectedCountry(e.value);

    if (e.value.option === "other" && thirdPartyStatus.option !== "approved") {
      updateSelectedRuc("0");
      updateShowRucModal(true);
      onChangeVolantesForInvoice();
      return;
    }

    updateSelectedRuc(e.value.option);
    onChangeVolantesForInvoice();
  };

  const countryOptionTemplate = (option) => {
    const optionOthers = option.option === "other" ? "" : " - ";
    return (
      <div style={{ cursor: "pointer" }}>
        <OptionTemplateVolante
          color="#08082B"
          fontWeight={600}
          marginBottom="0.2rem"
        >
          {option.ruc} {optionOthers}
          {option.name} {optionOthers} {option?.label}
        </OptionTemplateVolante>
        <OptionTemplateVolante color="#30345C" fontWeight={400}>
          <label>{option?.address}</label>
        </OptionTemplateVolante>
      </div>
    );
  };

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="country-item country-item-value">
          <div
            style={{
              fontSize: "1.4rem",
              fontWeight: 600,
              fontFamily: "Montserrat",
            }}
          >
            {option.name}
          </div>
        </div>
      );
    }
    return (
      <span style={{ fontSize: "1.4rem", fontFamily: "Montserrat" }}>
        {props.placeholder}
      </span>
    );
  };

  useEffect(() => {
    if (
      selectedRuc === "other" &&
      ["reviewing", "approved"].includes(thirdPartyStatus.option)
    ) {
      const findOtherLabel = rucOptions.find((resp) => resp.option === "other");
      setSelectedCountry(findOtherLabel);
    }
    // eslint-disable-next-line
  }, [selectedRuc]);

  return (
    <div>
      {showModalErrorAdditionalRucs && showModalMessageAdditionalRucs && (
        <ConfirmationModal
          title={"Atención"}
          message={showModalMessageAdditionalRucs}
          toggleModal={() => {
            setShowModalErrorAdditionalRucs(false);
            setShowModalMessageAdditionalRucs("");
          }}
          onAccept={() => {
            setShowModalErrorAdditionalRucs(false);
            setShowModalMessageAdditionalRucs("");
          }}
        />
      )}

      {showConfirmationModalVolanteDocument && (
        <ConfirmationModal
          title={"Documentos subidos con éxito"}
          message={
            "La carga de los documentos ha sido exitosa. Haga clic en entendido o cierre el diálogo para continuar."
          }
          toggleModal={() => {
            setShowConfirmationModalVolanteDocument(false);
            refreshBilling();
          }}
          onAccept={() => {
            setShowConfirmationModalVolanteDocument(false);
            refreshBilling();
          }}
        />
      )}
      <VolanteHeader
        amountReady={amount !== "(No cotizado)"}
        enableCheckbox={enableCheckbox}
      >
        {paymentStatus.option === "unquoted" && restrictions === 0 ? (
          <div>
            <input
              className="clickable-element"
              type="checkbox"
              checked={checked}
              onChange={checkboxOnChange}
              disabled={disabled || isReviewing}
              style={{
                cursor: `${
                  disabled || isReviewing ? "not-allowed" : "pointer"
                }`,
              }}
            />
          </div>
        ) : (
          <>&nbsp;</>
        )}
        <div className="main-info-header">
          <p>{importer}</p>
          <p className="id">{id}</p>
          <p className="entry-date">{`Ingresó el ${dateToRegularFormat(
            entryDate
          )}`}</p>
        </div>
        <div>
          <IntranetStatusSectionDetails
            invoice={{
              ...volante,
              status: volante.status2,
              quotationNum: volante.id,
            }}
          />
        </div>
        <div>
          <StatusSection>
            <StatusBar>
              <StatusDiv className="status" status={paymentStatus.category}>
                <span>{paymentStatus.label.toUpperCase()}</span>
              </StatusDiv>
            </StatusBar>
          </StatusSection>
        </div>
        <div>{formatNumber(weight)}</div>
        <div>{parcels}</div>
        <div>{daysStored}</div>
        <div>
          {volante.payment_status.option !== "unquoted" && (
            <>
              <p>{dateToRegularFormat(withdrawalDate)}</p>
            </>
          )}
          {volante.payment_status.option === "unquoted" && (
            <>
              {restrictions > 0 ? (
                <p>{dateToRegularFormat(new Date())}</p>
              ) : (
                <DivDate>
                  <DatePicker
                    className="clickable-element"
                    value={uploadDate}
                    onChange={uploadDateOnChange}
                    clearIcon={null}
                    dayPlaceholder={"dd"}
                    locale={"es-PE"}
                    monthPlaceholder={"mm"}
                    showLeadingZeros={true}
                    yearPlaceholder={"yy"}
                    maxDate={maxDate}
                    minDate={minDate}
                  />
                </DivDate>
              )}
            </>
          )}
        </div>
        <div>
          <Authorization
            actions={[
              "dam.get_dam_estimate",
              "volante.update_volante_quotation_estimate",
            ]}
          >
            {paymentStatus.option !== "unquoted" && restrictions === 0 ? (
              <p>{billableRuc.name}</p>
            ) : (
              <>
                <DivDropdown className="hollall">
                  <Dropdown
                    className="volante-dropdown-select-style"
                    panelClassName="panelVolanteDropdown"
                    value={selectedCountry}
                    disabled={
                      disabled ||
                      ["reviewing", "approved"].includes(
                        thirdPartyStatus.option
                      )
                    }
                    options={rucOptions}
                    onChange={onCountryChange}
                    optionLabel="name"
                    placeholder="(Ninguno)"
                    valueTemplate={selectedCountryTemplate}
                    itemTemplate={countryOptionTemplate}
                    style={{ width: "10rem" }}
                  />
                </DivDropdown>
              </>
            )}
          </Authorization>
        </div>
        <div className="amount">
          {isFetchingQuotation ? (
            <Skeleton height="3rem" />
          ) : restrictions > 0 ? (
            <> {"(No cotizado)"}</>
          ) : quotationProcessStatus?.option !== "processed" &&
            volante.payment_status.option === "quoted" ? (
            <> {"(No procesado)"}</>
          ) : (
            <>{formatMoney(amount, useDollars)}</>
          )}
        </div>
      </VolanteHeader>
      <VolanteDescription>
        <p>
          {contentDescription
            ? contentDescription
            : "Este volante no tiene ninguna descripción."}
        </p>
      </VolanteDescription>
      <VolanteDetail>
        <FlightInfo onClick={toggleDetail}>
          <div>
            <h2>Línea aérea</h2>
            <p>{airline}</p>
          </div>
          <div>
            <h2>Fecha de vuelo</h2>
            <p>{dateToRegularFormat(flightDate)}</p>
          </div>
          <div>
            <h2>Guía madre</h2>
            <p>{masterAirWaybill}</p>
          </div>
          <div>
            <h2>Guía hija</h2>
            <p>{houseAirWaybill}</p>
          </div>
          <Authorization actions={["quotation-detail.get_additional_services"]}>
            {volante.payment_status.option === "unquoted" && (
              <>
                {restrictions === 0 && (
                  <>
                    {!["reviewing", "aproved"].includes(
                      volante.third_party_billing_authorization_status.option
                    ) && (
                      <div>
                        <MainButton onClick={toggleServices}>
                          <img src={IconServiceMore} alt="" /> Servicio
                        </MainButton>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </Authorization>
        </FlightInfo>
        {showServiceStatusModal ? (
          <AdditionalServiceStatusModal
            toggleModal={() => updateShowServiceStatusModal(false)}
          />
        ) : null}
        <Authorization actions={["volante.update_volante_quotation_estimate"]}>
          {restrictions === 0 && showDetail && (
            <div>
              {isFetchingQuotation ? (
                <QuotationSkeleton />
              ) : (
                <DetailsContainer>
                  <VolanteDetails
                    volante={volante}
                    quotationDetails={quotationDetails}
                    disableServices={false}
                    onRemoveClick={(detail) => {
                      committedAdditionalServicesRef.current =
                        additionalServices.filter(
                          (service) => service.sap_code !== detail.sap_code
                        );
                      setDeletedItemsByDate((deletedItemsByDate) => {
                        const key = format(uploadDate, "yyyy-MM-dd");
                        const deletedAdditionalServices =
                          deletedItemsByDate[key] || [];
                        return {
                          ...deletedItemsByDate,
                          [key]: [
                            ...deletedAdditionalServices,
                            detail.sap_code,
                          ],
                        };
                      });
                    }}
                  />
                  <VolanteDetailCpt
                    detail={quotationDetailsTotal}
                    isTotal={true}
                    volante={volante}
                  ></VolanteDetailCpt>
                </DetailsContainer>
              )}
            </div>
          )}
        </Authorization>
      </VolanteDetail>
      {showRucModal ? (
        ["not_required", "rejected"].includes(thirdPartyStatus.option) ? (
          <Authorization actions={["billable-ruc.get_billable_rucs"]}>
            <AdditionalRucsModal
              toggleModal={toggleRucModal}
              updateOtherRucInfo={updateOtherRucInfo}
              closeModalRuc={closeModalRuc}
              showModalTercero={() => {}}
              setShowModalErrorAdditionalRucs={setShowModalErrorAdditionalRucs}
              setShowModalMessageAdditionalRucs={
                setShowModalMessageAdditionalRucs
              }
              updateShowRucModal={updateShowRucModal}
            />
          </Authorization>
        ) : (
          <AdditionalInfoReviewingModal toggleModal={toggleRucModal} />
        )
      ) : null}
      <Authorization
        actions={[
          "files.upload_files",
          "volante.update_volante_third_party_auth",
        ]}
      >
        {showUploadFileModal ? (
          <FileUploadAuthorizationModal
            volanteId={id}
            hideModal={() => {
              updateShowUploadFileModal(false);
              setSelectedCountry("");
            }}
            otherRucInfo={otherRucInfo}
            updateRucOptions={updateRucOptions}
            updateSelectedRuc={(option) => {
              updateSelectedRuc(option);
            }}
            updateVolanteThirdParty={updateVolanteThirdParty}
            hideModalAuthorization={() => {
              updateShowUploadFileModal(false);
              setSelectedCountry("");
            }}
            showUploadFileModal={showUploadFileModal}
            setShowConfirmationModalVolanteDocument={
              setShowConfirmationModalVolanteDocument
            }
            showConfirmationModalVolanteDocument={
              showConfirmationModalVolanteDocument
            }
          />
        ) : null}
      </Authorization>
      <Sidebar
        id="vol-aditional-serive-id"
        style={{
          overflowX: "initial",
          width: "70rem",
        }}
        position="right"
        visible={volanteServiceSidebar}
        onHide={() => {
          setVolanteServiceSidebar(false);
        }}
        maskClassName="class-name-sidebar-style-services-additional"
      >
        <VolanteAdditionalServices
          dni={dni}
          onSave={(additionalServices) => {
            return new Promise((resolve, reject) => {
              loadQuotation(
                format(uploadDate, "yyyy-MM-dd"),
                additionalServices ?? [],
                {
                  onSuccess: (data) => {
                    committedAdditionalServicesRef.current =
                      additionalServices ?? [];
                    setDeletedItemsByDate({});
                    setVolanteServiceSidebar(false);
                    resolve(data);
                  },
                  onError: reject,
                } as any
              );
            });
          }}
          onOutsideClick={toggleVolanteServiceSidebar}
          additionalServices={additionalServices}
          volante={volante}
          uploadDate={uploadDate}
          dam_num={volante.pricing.dam_num}
        />
      </Sidebar>
    </div>
  );
}

export default Volante;
